module.exports = __webpack_public_path__ + "media/placeholders/persona-a9e3f409.png";